import React from 'react';
import { Create } from 'react-admin';
import AreaInfoForm from './NearbyForm'

export const NearbyCreate = (props) => (
    <Create title='Area info' {...props}>
        <AreaInfoForm />
    </Create>
);


// WEBPACK FOOTER //
// ./src/components/nearby/NearbyCreate.js